export default "__VITE_ASSET__BT_pDAL4__"